export default "__VITE_ASSET__3Kr7HqTE__"